import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import config from "config"

// ==================== CONFIGURACIONES HORARIOS ====================

async function fetchConfiguraciones(params = {}) {
  const queryParams = new URLSearchParams()

  if (params.dependenciaId) queryParams.append("dependenciaId", params.dependenciaId)
  if (params.tipoAsistenteId) queryParams.append("tipoAsistenteId", params.tipoAsistenteId)
  if (params.diaSemana) queryParams.append("diaSemana", params.diaSemana)
  if (params.activo !== undefined) queryParams.append("activo", params.activo)
  if (params.page !== undefined) queryParams.append("page", params.page)
  if (params.size !== undefined) queryParams.append("size", params.size)

  let url = `${config.api.baseURL}/configuraciones-horarios-asistencia`
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }

  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener las configuraciones de horarios")
      }
      return response.json()
    })
    .then((data) => {
      // El backend retorna estructura paginada: {content: [...], totalElements, totalPages, ...}
      return data.content || []
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      return []
    })
}

async function fetchConfiguracionById(id) {
  let url = `${config.api.baseURL}/configuraciones-horarios-asistencia/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener la configuración de horario")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function createConfiguracion(data) {
  let url = `${config.api.baseURL}/configuraciones-horarios-asistencia`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.error || "Error al crear la configuración de horario")
        })
      }
      return response.json()
    })
    .then((result) => {
      showToast({ title: "Configuración de horario creada exitosamente", icon: "success" })
      return result
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function updateConfiguracion(id, data) {
  let url = `${config.api.baseURL}/configuraciones-horarios-asistencia/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.error || "Error al actualizar la configuración de horario")
        })
      }
      return response.json()
    })
    .then((result) => {
      showToast({ title: "Configuración de horario actualizada exitosamente", icon: "success" })
      return result
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function deleteConfiguracion(id) {
  return Swal.fire({
    title: "¿Está seguro?",
    text: "Esta acción eliminará la configuración de horario permanentemente",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      let url = `${config.api.baseURL}/configuraciones-horarios-asistencia/${id}`
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response?.ok) {
            return response.json().then((error) => {
              throw new Error(error.error || "Error al eliminar la configuración de horario")
            })
          }
          showToast({ title: "Eliminado", text: "La configuración de horario ha sido eliminada", icon: "success" })
          return true
        })
        .catch((error) => {
          showToast({ icon: "error", title: "Error", text: error.message })
          throw error
        })
    }
    return false
  })
}

// ==================== ORGANIZACIONES (para dropdown) ====================

async function fetchDependencias(params = {}) {
  const queryParams = new URLSearchParams()
  if (params.sucursalId) queryParams.append("sucursalId", params.sucursalId)

  let url = `${config.api.baseURL}/dependencias-asistencia`
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }

  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener las organizaciones")
      }
      return response.json()
    })
    .then((data) => {
      return data.content || []
    })
    .catch((error) => {
      console.error("Error loading organizaciones:", error)
      return []
    })
}

// ==================== TIPOS DE ASISTENTE (para dropdown) ====================

async function fetchTiposAsistente() {
  let url = `${config.api.baseURL}/tipos-asistente`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener los tipos de asistente")
      }
      return response.json()
    })
    .then((data) => {
      return data.content || []
    })
    .catch((error) => {
      console.error("Error loading tipos de asistente:", error)
      return []
    })
}

export {
  fetchConfiguraciones,
  fetchConfiguracionById,
  createConfiguracion,
  updateConfiguracion,
  deleteConfiguracion,
  fetchDependencias,
  fetchTiposAsistente,
}
